export default __webpack_public_path__ + "static/media/linkedin.0bf111d2.svg";